import { Typography } from 'antd';
import AppConfigurationSettings from '../../components/AppConfigurationSettings';

const { Title } = Typography;

export default function FeedbackAppConfiguration() {
  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <Title level={2} className="text-3xl font-bold text-gray-900 mb-2">
          App Configuration
        </Title>
        <p className="text-sm text-gray-600">
          Manage your Feedback application sidebar and settings. Toggle menu items on/off and reorder them by dragging.
        </p>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="p-6">
          <AppConfigurationSettings 
            applicationFilter="feedback"
            defaultApplication="feedback"
          />
        </div>
      </div>
    </div>
  );
}
